function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React from "react";
import { updateContextState } from "../";
import { basicTagReplacer } from "../../../utils/proposals/tag-replacer";
import { generateTransaction } from "../../../utils/transactions";
import { getCartId } from "../../../utils/product/getCartId";
import { requests } from "../../../modules/proposals";
import { context } from "../wr-context";
import utils from "../../../modules/product/product-utils";
import mixpanel from "mixpanel-browser";
import { isAnalyticsEnabled } from "../../../modules/analytics";
export var CartProductActionType;
(function(CartProductActionType) {
    CartProductActionType["Add"] = "add";
    CartProductActionType["Remove"] = "remove";
})(CartProductActionType || (CartProductActionType = {}));
var actions = {
    addProductToCart: function(_product) {
        return updateContextState(function(state) {
            var product = _objectSpread({}, _product);
            if (product.values && product.values.cartId) {
                var existingProductIndex = context.state.cart.findIndex(function(v) {
                    return v.cartId === product.values.cartId;
                });
                product.cartId = state.cart[existingProductIndex].cartId;
                delete product.values.cartId;
                if (existingProductIndex !== -1) {
                    state.cart[existingProductIndex] = product;
                }
            } else {
                var ref;
                if (context.getRoutePath("updateProduct") === "" || !((ref = window.location.href) === null || ref === void 0 ? void 0 : ref.includes(context.getRoutePath("updateProduct"))) || context.constants.product.addToCartSkippingDetails) {
                    product.cartId = state.cart.find(function(cartItem) {
                        return cartItem.id + cartItem.cartId === product.id + product.cartId;
                    }) ? getCartId() : product.cartId;
                    product.quantity = 1;
                    state.cart = _toConsumableArray(state.cart).concat([
                        product
                    ]);
                }
            }
            if (isAnalyticsEnabled()) {
                // Collects the decision tree path to append at the mixpanel tracking event
                var pathValues = [];
                if (Object.keys(state.decisionTreeAnswers).length) {
                    pathValues = Object.keys(state.decisionTreeAnswers).reduce(function(acc, curr) {
                        acc.push("Q: " + state.decisionTreeAnswers[curr].question.value);
                        acc.push("A: " + state.decisionTreeAnswers[curr].value);
                        return acc;
                    }, []);
                }
                mixpanel.track(context.constants.analytics.serviceAddedToCart, _objectSpread({
                    serviceId: product.id,
                    categoryFilters: state.categoryFilters
                }, pathValues.length && {
                    decisionTreePath: pathValues.join(" -> ")
                }));
            }
        });
    },
    updateQuantityInCartProduct: function(productId, actionType) {
        return updateContextState(function(state) {
            var itemIndex = state.cart.findIndex(function(cartItem) {
                return cartItem.id === productId;
            });
            var serviceQuantityUpdatedEvent = context.constants.analytics.serviceQuantityUpdated;
            if (actionType === "add") {
                var ref;
                state.cart[itemIndex].quantity = (((ref = state.cart[itemIndex]) === null || ref === void 0 ? void 0 : ref.quantity) || 0) + 1;
                mixpanel.track(serviceQuantityUpdatedEvent, {
                    actionType: "add"
                });
            } else {
                var ref1;
                state.cart[itemIndex].quantity = (((ref1 = state.cart[itemIndex]) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0) - 1;
                mixpanel.track(serviceQuantityUpdatedEvent, {
                    actionType: "remove"
                });
            }
        });
    },
    removeProductFromCart: function(productId, product) {
        return updateContextState(function(state) {
            var multiple = context.utils.products.allowsMultipleSameProductsInCart(product);
            var productIndex = multiple ? state.cart.indexOf(product) : state.cart.findIndex(function(v) {
                return v.id === productId;
            });
            if (productIndex !== -1) {
                state.cart = _toConsumableArray(state.cart.slice(0, productIndex)).concat(_toConsumableArray(state.cart.slice(productIndex + 1)));
                mixpanel.track(context.constants.analytics.serviceRemovedFromCart, {
                    serviceId: productId
                });
            }
        });
    },
    addProductToDecisionTreeCart: function(product) {
        return updateContextState(function(state) {
            state.decisionTreeCart = _defineProperty({}, product.id, product);
        });
    },
    updateCategoryFilters: function(id) {
        return updateContextState(function(state) {
            var categoryFilters = state.categoryFilters;
            state.categoryFilters = categoryFilters.find(function(filter) {
                return filter === id;
            }) ? categoryFilters.filter(function(filter) {
                return filter !== id;
            }) : _toConsumableArray(categoryFilters).concat([
                id
            ]);
        });
    },
    resetCategoryFilters: function() {
        return updateContextState(function(state) {
            state.categoryFilters = [];
        });
    },
    updateFilters: function(ids) {
        return updateContextState(function(state) {
            state.activeFilters = ids.slice();
        });
    },
    updateSorting: function(sorting) {
        return updateContextState(function(state) {
            state.activeSorting = sorting;
        });
    },
    updateCartProductValues: function(productId, productCartIdParam, values) {
        return updateContextState(function(state) {
            var index = state.cart.findIndex(function(el) {
                return productCartIdParam ? el.id + el.cartId === productId + productCartIdParam : el.id === productId;
            });
            if (index !== -1) {
                state.cart[index].values = values;
                state.cart[index].price = utils.getPrice(state.cart[index]);
            }
        });
    },
    resetCarts: function() {
        return updateContextState(function(state) {
            state.cart = [];
            state.decisionTreeCart = {};
        });
    },
    logout: function() {
        return updateContextState(function(state) {
            state.isLoggedIn = false;
            state.user = {};
            state.authorization = "";
            context.persistentStorage.remove("token");
            context.persistentStorage.remove(context.constants.sso.tokenStorageKey);
        });
    },
    openModal: function(param) {
        var header = param.header, body = param.body, footer = param.footer, component = param.component, showClose = param.showClose, persistent = param.persistent, size = param.size;
        return updateContextState(function(state) {
            state.modal.isOpen = true;
            state.modal.body = body;
            state.modal.header = header;
            state.modal.footer = footer;
            state.modal.component = component;
            state.modal.showClose = showClose;
            state.modal.persistent = persistent;
            state.modal.size = size;
        });
    },
    closeModal: function() {
        return updateContextState(function(state) {
            state.modal.isOpen = false;
            state.modal.body = null;
            state.modal.header = null;
            state.modal.footer = null;
            state.modal.component = null;
            state.modal.showClose = null;
            state.modal.persistent = false;
            state.modal.size = null;
        });
    },
    updateMaxPriceFilterValue: function(maxValue) {
        return updateContextState(function(state) {
            state.priceFilter.maxValue = parseInt(String(maxValue));
        });
    },
    updatePriceFilterValues: function(values) {
        return updateContextState(function(state) {
            state.priceFilter.values = values;
        });
    },
    generateProposal: function(param) {
        var id = param.id, asDraft = param.asDraft, asQuotePdf = param.asQuotePdf, asQuoteWord = param.asQuoteWord, formValues = param.formValues, html = param.html, fromDecisionTree = param.fromDecisionTree, clientName = param.clientName, proposalName = param.proposalName, _noTagReplacement = param.noTagReplacement, noTagReplacement = _noTagReplacement === void 0 ? false : _noTagReplacement, _settings = param.settings, settings = _settings === void 0 ? {} : _settings, value = param.value, _email = param.email, email = _email === void 0 ? "" : _email, callback = param.callback, _requiresAuth = param.requiresAuth, requiresAuth = _requiresAuth === void 0 ? true : _requiresAuth, _preserveSettings = param.preserveSettings, preserveSettings = _preserveSettings === void 0 ? true : _preserveSettings;
        var updatedHtml = noTagReplacement ? html : basicTagReplacer(html, formValues);
        var status = asQuotePdf ? "quotePdf" : asQuoteWord ? "quoteWord" : "draft";
        var companyName = formValues === null || formValues === void 0 ? void 0 : formValues.company;
        var request;
        var options = {
            id: id,
            html: updatedHtml,
            status: status,
            date: formValues === null || formValues === void 0 ? void 0 : formValues.desiredStartDate,
            fromDecisionTree: fromDecisionTree,
            name: clientName || (formValues === null || formValues === void 0 ? void 0 : formValues.name),
            proposalName: proposalName,
            companyName: companyName,
            settings: settings,
            value: value,
            email: email,
            callback: callback,
            requiresAuth: requiresAuth,
            preserveSettings: preserveSettings
        };
        if (asDraft) {
            request = requests.createDraftProposal(options);
        } else if (asQuoteWord) {
            request = requests.createDocx(options);
        } else {
            request = requests.createPDF(options);
        }
        return Promise.all([
            request
        ]);
    },
    /* @deprecated */ logIndexTransaction: function() {
        var transaction = {
            action: "viewed",
            type: "page",
            id: "home"
        };
        // ignore the any, this is no longer used
        generateTransaction(transaction);
    },
    setAnswers: function(answers) {
        return updateContextState(function(state) {
            state.decisionTreeAnswers = _objectSpread({}, answers);
        });
    },
    resetAnswers: function() {
        return updateContextState(function(state) {
            state.decisionTreeAnswers = [];
        });
    }
};
export default actions;
